type Options = {
  isGrouped: boolean;
};

export function getProductDotMenuLabel({ isGrouped }: Options): string {
  return isGrouped ? 'Delete group' : 'Grouped products';
}
